import React from 'react';

const NebulaUserProfileHistoryFormModal = React.lazy(() => import('../components/FormModal'));
const nebulaUserProfileHistoryModalRegistry = {
    personalize_nebulaUserProfileHistoryId: NebulaUserProfileHistoryFormModal
};
export default nebulaUserProfileHistoryModalRegistry;
